import React from 'react';
import { Icon } from './Icon.js';
export const IconBagShopping3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 11V4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4V11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M5.00004 7L3 21H21L19 7H5.00004Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBagShopping3.js.map